import * as React from "react"

function InputDown(props) {
  return (
    <svg
    className={`w-4 lg:w-6  transition-transform origin-center duration-300 ${props.open ? `rotate-180` : `rotate-0`}`}
    viewBox="0 0 24 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 3l9.333 9.226L21.667 3"
        stroke="#0C1414"
        strokeWidth={3}
        strokeLinecap="square"
      />
    </svg>
  )
}

export default InputDown
